module.exports = __webpack_public_path__ + "static/media/bug_fixing.32c1ac6e.svg";